/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Status_ConnectedInputs */

const en_live_caption_status_connected = /** @type {(inputs: Live_Caption_Status_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connected`)
};

const fr_live_caption_status_connected = /** @type {(inputs: Live_Caption_Status_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connecté`)
};

const de_live_caption_status_connected = /** @type {(inputs: Live_Caption_Status_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbunden`)
};

const it_live_caption_status_connected = /** @type {(inputs: Live_Caption_Status_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collegato`)
};

const ru_live_caption_status_connected = /** @type {(inputs: Live_Caption_Status_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подключено`)
};

const es_live_caption_status_connected = /** @type {(inputs: Live_Caption_Status_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conectado`)
};

const zh_cn2_live_caption_status_connected = /** @type {(inputs: Live_Caption_Status_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已连接`)
};

const ja_live_caption_status_connected = /** @type {(inputs: Live_Caption_Status_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接続済み`)
};

const hi_live_caption_status_connected = /** @type {(inputs: Live_Caption_Status_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जुड़े हुए`)
};

const pt_pt2_live_caption_status_connected = /** @type {(inputs: Live_Caption_Status_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conectado`)
};

/**
* | output |
* | --- |
* | "Connected" |
*
* @param {Live_Caption_Status_ConnectedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_status_connected = /** @type {((inputs?: Live_Caption_Status_ConnectedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Status_ConnectedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_status_connected(inputs)
	if (locale === "de") return de_live_caption_status_connected(inputs)
	if (locale === "it") return it_live_caption_status_connected(inputs)
	if (locale === "ru") return ru_live_caption_status_connected(inputs)
	if (locale === "es") return es_live_caption_status_connected(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_status_connected(inputs)
	if (locale === "ja") return ja_live_caption_status_connected(inputs)
	if (locale === "hi") return hi_live_caption_status_connected(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_status_connected(inputs)
	return en_live_caption_status_connected(inputs)
});